import { render, staticRenderFns } from "./especiales.vue?vue&type=template&id=0f7fa7d9&scoped=true"
import script from "./especiales.vue?vue&type=script&lang=js"
export * from "./especiales.vue?vue&type=script&lang=js"
import style0 from "./especiales.vue?vue&type=style&index=0&id=0f7fa7d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7fa7d9",
  null
  
)

export default component.exports